module.exports = __webpack_public_path__ + "img/slide_three.75bd2bee.jpg";